import React, { useEffect } from "react";
import useHandleBoxTypes from "../hooks/useHandleBoxTypes";
import MainStore from "../stores/MainStore";

const NoneSelectedHolder = ({
  setShowActive,
  from,
  height = "60%",
  width = "60%",
}) => {
  const [boxType, setBoxType] = React.useState(null);
  const { getBoxType } = useHandleBoxTypes();
  const { player } = MainStore();

  useEffect(() => {
    setBoxType(getBoxType("goal"));
  }, []);

  return (
    <div className="divRow">
      <img
        className="icon40"
        src={"/icons/icon_back.png"}
        onClick={() => {
          setShowActive(false);
        }}
      />
      <div
        className="divRow"
        style={{
          marginLeft: "20px",
          height,
          width,
          backgroundColor: boxType ? boxType.colors.primary : null,
          justifyContent: "center",
          borderRadius: "1rem/1rem",
        }}
      >
        <div
          className="textBoldWhite"
          style={{ fontSize: "20px", textAlign: "center" }}
        >
          {`No Active ${from} at the moment`}
        </div>
      </div>
    </div>
  );
};

export default NoneSelectedHolder;
